import type { GenericPosition } from "@brickme/project-core/src/model/geom.ts";

type ActiveTouches = ReadonlyMap<number, GenericPosition<number>>;

function getTouchDistance(touches: ActiveTouches): number | undefined {
	const points = Array.from(touches.values());
	if (points.length < 2) {
		return undefined;
	}
	const dx = points[1].x - points[0].x;
	const dy = points[1].y - points[0].y;
	return Math.sqrt(dx * dx + dy * dy);
}

function getTouchCenter(
	touches: ActiveTouches,
): GenericPosition<number> | undefined {
	const points = Array.from(touches.values());
	if (points.length < 2) {
		return undefined;
	}
	return {
		x: (points[0].x + points[1].x) / 2,
		y: (points[0].y + points[1].y) / 2,
	};
}

export type { ActiveTouches };
export { getTouchDistance, getTouchCenter };
